module.exports = __webpack_public_path__ + "img/Union.392bbeae.svg";